module.exports = __webpack_public_path__ + "img/luis-pineda.cf1deda6.png";